import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import AddIcon from '@mui/icons-material/Add';
import PrescriptionPrintComponent from '../prescriptions/PrescriptionPrintComponent';

const PrescriptionsTab = ({ prescriptions, patient, encounter, onPrescriptionsChange, onAddPrescription }) => {
  const [printDialogOpen, setPrintDialogOpen] = useState(false);
  const activePrescriptions = prescriptions.filter(p => p.status === 'active' || !p.status);

  return (
    <Box>
      {/* Action buttons - always show Add button */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Prescriptions {activePrescriptions.length > 0 ? `(${activePrescriptions.length} active)` : ''}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {onAddPrescription && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onAddPrescription}
              size="small"
              sx={{ 
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: '8px',
              }}
            >
              Add Prescription
            </Button>
          )}
          {activePrescriptions.length > 0 && (
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => setPrintDialogOpen(true)}
              size="small"
              sx={{ 
                textTransform: 'none',
                fontWeight: 600,
                borderColor: 'primary.main',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: 'white'
                }
              }}
            >
              Print Prescriptions
            </Button>
          )}
        </Box>
      </Box>

      {prescriptions && prescriptions.length > 0 ? (
        <Box>
          <List>
            {prescriptions.map((prescription, index) => (
              <ListItem key={prescription.id || index} divider>
                <ListItemText
                  primary={
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {prescription.medicationName || prescription.medication || 'Unknown medication'}
                    </Typography>
                  }
                  secondary={
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        {prescription.dosage || 'N/A'} • {prescription.frequency || 'N/A'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {prescription.instructions || 'No special instructions'}
                      </Typography>
                      <br />
                      <Typography variant="caption" color="text.secondary">
                        Status: {prescription.status || 'Active'} • 
                        Provider: {prescription.provider || 'N/A'}
                      </Typography>
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            No prescriptions found for this encounter
          </Typography>
          {onAddPrescription && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Click "Add Prescription" above to create one
            </Typography>
          )}
        </Box>
      )}

      {/* Print Dialog */}
      <PrescriptionPrintComponent
        prescriptions={prescriptions}
        patient={patient}
        encounter={encounter}
        facilityId={encounter?.facilityId || patient?.facilityId}
        open={printDialogOpen}
        onClose={() => setPrintDialogOpen(false)}
        onPrint={() => setPrintDialogOpen(false)}
      />
    </Box>
  );
};

export default PrescriptionsTab; 